/**
 * @file 反馈页的请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest2 from '../baseApi2';


// 提交反馈表单
export interface IFeedbackApiSubmitParam {
    // 用户名
    name: string;
    // 问题
    problems: string;
    // 电话
    phoneNumber: string;
    // 验证码
    verifyCode: string,
    // 验证码校验字符串，原封不动的返回给服务端
    randomStr: string;
    // 来源
    source: string;
}

export const fetchSubmit = (params: IFeedbackApiSubmitParam): Promise<request.Response> =>
    baseRequest2(
        request.post('/platform/usercase/send')
            .query({type: 10})
            .send(params)
    );
